module.exports = __webpack_public_path__ + "static/hero-e3b746bf5281abef2b35ff97b178d769.png";